import { deleteRequest, getRequest, postRequest, putRequest } from "../../apiClient";
import { BillingsEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetBillings = async (queryString: any) => {
    var _url = BillingsEndpoint.BILLINGS_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetBillingById = async (id: string | number) => {
    var _url = BillingsEndpoint.BILLING_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreateBillingService = async (param: any) => {
    var res = await postRequest(BillingsEndpoint.BILLINGS_URL, param);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditBillingService = async (id: string | number, param: any) => {
    var res = await putRequest(BillingsEndpoint.BILLING_BY_ID_URL(id), param);

    return res;
};

export const SettleBillingService = async (id: string | number, param: any) => {
    var res = await putRequest(BillingsEndpoint.BILLING_SETTLE_BY_ID_URL(id), param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const DeleteBillingService = async (id: string | number, param: any) => {
    var _url = BillingsEndpoint.BILLING_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};

//#endregion